var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import Form from "@irati/ui/src/Form";
import { Checkbox } from "@irati/ui/src/FormItem";
import { Label1 } from "@irati/ui/src/Labels";
import authentication from "@irati/auth";
import { canModifyUserMembership } from "@irati/identity/utils/team/membership";
import User from "../../Users/User/index";
var AddUserToTeamUserRow = /** @class */ (function (_super) {
    __extends(AddUserToTeamUserRow, _super);
    function AddUserToTeamUserRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.userAlreadyInTeam = function (user) {
            var currentTeam = _this.props.currentTeam;
            return user.teamIds.find(function (teamId) { return teamId === currentTeam.uuid; });
        };
        _this.action = function (user) {
            var _a = _this.props, updateSelectedUser = _a.updateSelectedUser, selectedEmployees = _a.selectedEmployees;
            if (_this.userAlreadyInTeam(user)) {
                return (React.createElement(Label1, null,
                    React.createElement(FormattedMessage, { id: "admin.components.addUserToTeamUserRow.labelOne" })));
            }
            else if (canModifyUserMembership(_this.props.currentTeam, authentication.user(), user)) {
                return (React.createElement(Form, null,
                    React.createElement(Checkbox, { name: user.uuid, className: "pull-right", checked: !!selectedEmployees.find(function (selectedEmployee) { return selectedEmployee.uuid === user.uuid; }), onChange: function () { return updateSelectedUser(user); } })));
            }
            return null;
        };
        return _this;
    }
    AddUserToTeamUserRow.prototype.render = function () {
        var user = this.props.user;
        return React.createElement(User, { user: user, rowData: user.email, lowercaseRowData: true, showCheckbox: false, action: this.action(user) });
    };
    return AddUserToTeamUserRow;
}(PureComponent));
export default AddUserToTeamUserRow;
